import axios from './config/config-viva'

const defaultRoute = 'conveniados/'

export default {
    list: (grupo=null, page=null, limit=null, filter=null, ocultarTabela=null, statusConveniado=null) => {
        return axios.get(`${defaultRoute}?value=1${grupo?'&grupo='+grupo:''}${
            page?'&page='+page:''}${
            limit?'&limit='+limit:''}${
            filter?'&onFilter='+filter:''}${
            ocultarTabela?'&ocultarTabela='+ocultarTabela:''
            }${statusConveniado?'&status='+statusConveniado:''
            }`)
    },
    listBySelect(){
        return axios.get(`${defaultRoute}select`)
    },
    findOne(id, ocultarTabela = null){
        return axios.get(`${defaultRoute}one/${id}/${ocultarTabela?'?ocultarTabela='+ocultarTabela: ''}`)
    },
    create: (conveniado) => {
        return axios.post(defaultRoute, conveniado)
    },
    update: (id, conveniado) => {
        return axios.put(defaultRoute+id, conveniado)
    },
    remove: (id) => {
        return axios.delete(defaultRoute+id)
    },
    uploadFile:(file, fileName,id)=>{
        return axios.post(defaultRoute+'upload-files/'+id+`?fileName=${fileName}`,file)
    },
    orcamento: (grupo, plano) => {
        return axios.get(`${defaultRoute}orcamento?grupo=${grupo}${plano?'&plano='+plano:''}`)
    },
    searchByName: (nome, page, limit) => {
        return axios.get(`${defaultRoute}search/name?nome=${nome}&page=${page}&limit=${limit}`)
    },
    updateTabelaPreco:(id, tabelaPreco) => {
        return axios.patch(defaultRoute+id, tabelaPreco)
    },
    registrarPreco: (preco) => {
        return axios.post(`${defaultRoute}save-table-price`, preco)
    },
    importTabelaPreco: (file, body) => {
        let formData = new FormData()
        formData.append('file', file)
        formData.append('conveniado_id', body.conveniadoId)
        formData.append('plano_id', body.planoId)
        return axios.put(`${defaultRoute}import-tabela-preco`, formData)
    },
    findOneTabela(id, procedimento = null, allProcedimentos = null) {
        return axios.get(`${defaultRoute}find/tabela/${id}/${procedimento ? '?procedimento=' + procedimento : ''}${allProcedimentos ? '?allProcedimentos=' + allProcedimentos : ''}`)
    },
    searchProcedimentoInTabelaByName(id, procedimento) { 
        return axios.get(`${defaultRoute}search/tabela/${id}/procedimento/${procedimento}`)
    }
}
